import { redirect, type ActionFunction } from "react-router";

import { Api } from "@/services";
import { httpSuccessToast } from "@/utils";

export const deleteJobAction: ActionFunction = async ({ params }) => {
  const resp = await Api.DeleteJob(params.id!);
  httpSuccessToast(resp, "Job deleted successfully");

  return redirect("../all-jobs");
};
